import { useDeviationMatureFilter } from '../../../utils/hooks/useDeviationMatureFilter';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { useOverlayContext } from '../../hooks/useOverlayContext';
export function useDeviationBlockType(deviation) {
    var _a = useOverlayContext(deviation), showPremiumFolderOverlay = _a.showPremiumFolderOverlay, showSubscriberOverlay = _a.showSubscriberOverlay;
    var _b = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), isPremiumLocked = _b.isPremiumLocked, isPaidFolder = _b.isPaidFolder, isWatchToAccess = _b.isWatchToAccess;
    var _c = useSubscriptionTier(deviation), needsSubscription = _c.needsSubscription, isSubscribedButBlocked = _c.isSubscribedButBlocked;
    var showBlocked = useDeviationMatureFilter(deviation).showBlocked;
    if (showBlocked) {
        return 'matureFilter';
    }
    if (isPremiumLocked && isPaidFolder && showPremiumFolderOverlay) {
        return 'premiumFolder';
    }
    if (isPremiumLocked && isWatchToAccess && showPremiumFolderOverlay) {
        return 'watchersOnly';
    }
    if (needsSubscription && showSubscriberOverlay) {
        return 'subsOnly';
    }
    if (isSubscribedButBlocked && showSubscriberOverlay) {
        return 'subBlocked';
    }
}
//# sourceMappingURL=useDeviationBlockType.js.map